module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/qhead10-a71d25d5ba2e008338f30751cf1ce882.jpg";